import { render, staticRenderFns } from "./CurrentEmployeeInfo.vue?vue&type=template&id=4fa57ee2&scoped=true&"
import script from "./CurrentEmployeeInfo.vue?vue&type=script&lang=js&"
export * from "./CurrentEmployeeInfo.vue?vue&type=script&lang=js&"
import style0 from "./CurrentEmployeeInfo.vue?vue&type=style&index=0&id=4fa57ee2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa57ee2",
  null
  
)

export default component.exports